import { render, staticRenderFns } from "./WConfirm.vue?vue&type=template&id=0848514c&scoped=true&lang=pug&"
import script from "./WConfirm.vue?vue&type=script&lang=js&"
export * from "./WConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0848514c",
  null
  
)

export default component.exports